export const rejectonboardingBusinessSaga = (state) => state.rejectbusinessInfoReducer.businessInfoSuccess;
export const rejectonboardingBusinessErrorSaga = (state) => state.rejectbusinessInfoReducer.businessInfoError;
